import React from "react";
import "./Internship.scss";
import { useLocation } from "react-router-dom";


const Internship = () => {
  const location = useLocation()
      const select = location.pathname.includes('/it-internship') ?'Internship' : location.pathname.includes('/it-training') ? 'Learning' : 'choose';



  return (
    <section className="internship-section">
      <div className="intern-main">
        <h2>
           Explore Our <span>{select}</span> Domains
        </h2>
        <p className="intern-sub">
        Choose a field that aligns with your goals — gain hands-on experience with
          real-world projects and professional mentorship.
        </p>
      </div>
    </section>
  );
};

export default Internship;
